import type { SetURLSearchParams } from 'react-router';

/** Set `?id=` search param without disturbing other params */
export function setUrlId(setSearchParams: SetURLSearchParams, id: string) {
  setSearchParams(
    (prev) => {
      const next = new URLSearchParams(prev);
      next.set('id', id);
      return next;
    },
    { replace: true },
  );
}

/** Remove `?id=` search param without disturbing other params */
export function clearUrlId(setSearchParams: SetURLSearchParams) {
  setSearchParams(
    (prev) => {
      const next = new URLSearchParams(prev);
      next.delete('id');
      return next;
    },
    { replace: true },
  );
}
